import { ReactNode } from 'react';
import { MantineProvider } from '@mantine/core';

import { mantineTheme } from '../mantineTheme';

type Props = { children: ReactNode };

export function OnboardingMantineRoot({ children }: Props) {
    return (
        <MantineProvider theme={mantineTheme}>
            {children}
        </MantineProvider>
    );
}
